



















































































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Curso } from '@/__env/lib/Cursos';
import detalles from './curso-detalles.vue';
import preguntas from './curso-preguntas.vue';
import finalizado from './curso-finalizado.vue';
import progreso from './curso-progreso.vue';
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import { Wait } from '@/__env/ext';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
@Component( {
    name: "Componente",
    props: {},
    components: {
        detalles,
        preguntas,
        progreso,
        finalizado
    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado ? Model.Resultado : null; }

    public Estado: 'cargando' | 'ok' | 'error' | 'iniciado' = 'iniciado';
    public Iniciando: boolean = false;
    public Modo: 'preguntas' | 'detalles' | 'error' | 'resultado' | 'iniciado' = 'detalles';
    iniciar()
    {
        this.Estado = 'cargando';

        if ( !this.Curso )
        {
            this.Modo = 'error';

        }
        else
        {
            if ( this.Resultado && this.Resultado.Finalizado )
                this.Modo = 'resultado';
            else if ( this.Resultado && !this.Resultado.Finalizado )
                this.Modo = 'iniciado';
            else
                this.Modo = 'detalles';
        }
        this.$nextTick( () => this.Estado = 'ok' );
    }

    async created()
    {
        this.Estado = 'cargando';
        this.Controlador.$on( 'change', () => this.iniciar() );

        if ( this.$route.params.id )
        {
            await this.Controlador.Iniciar( await Curso.create( 0, this.$route.params.id ) );
        }
        else
        {
            this.Estado = 'ok';
            this.Modo = 'error';
        }
    }

    async iniciarCurso()
    {
        this.Iniciando = true;
        let e = await this.Controlador.IniciarCurso();
        if ( e )
        {
            await Wait( 1000 );
            this.Iniciando = false;
            this.Modo = 'preguntas';
        } else
        {
            this.Iniciando = false;
            this.$EventBus.Notificaciones.Error( 'Ocurrió un error' );
        }

    }

}
